import { CmsWebsiteBM } from '../types/cms.types.js'
import { WebsiteType } from '../types/website.base.types.js'
import { AnyWebsiteBM } from '../types/website.base.types.js'
import { WebsiteBM } from '../types/website.types.js'

export function isCmsWebsite(website: AnyWebsiteBM): website is CmsWebsiteBM {
  return website.type === WebsiteType.CMS_WEBSITE
}

export function isAtlasWebsit(website: AnyWebsiteBM): website is WebsiteBM {
  return website.type === WebsiteType.ATLAS_WEBSITE
}
